import { css } from '@emotion/react';
import sctheme from 'app/styles/sctheme';

const styles = sctheme => css`
  .title-search {
    display: flex;
    width: 50%;
    margin-left: auto;
  }

  .title-search-input {
    overflow: hidden;
    transition: all 250ms ease-out;
    transform: scaleX(0);
    transform-origin: right;
  }

  .title-search-input--expanded {
    transform: scaleX(1);
  }

  .table-header {
    display: grid;
    grid-template-columns: 2fr 1fr 1.5fr 1fr 1fr 1fr;
    gap: 4px;
    padding: 1rem 0;
    border-bottom: 2px solid #808080;
  }

  .table-results {
    display: grid;
    grid-template-columns: 2fr 1fr 1.5fr 1fr 1fr 1fr;
    gap: 4px;
  }

  .results-wrapper {
    border-bottom: 1px solid #dddddd;
    padding: 1rem;
  }

  .subscriber-toggle {
    color: ${sctheme.blues.secondary};
    cursor: pointer;
  }

  .project-info {
    text-align: left;
    position: absolute;
    top: 100%;
    left: 100%;
    transform: translateX(-50%);
    width: 12rem;
    background-color: ${sctheme.white};
    z-index: 10;
    box-shadow: 0px 1px 8px 0px #00000080;
    font-size: 12px;
    margin-top: 0.5rem;
    box-sizing: border-box;
    pointer-events: none;

    &.previous-invoiced {
      transform: translateX(-60%);
    }
  }

  .project-info::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid ${sctheme.white};
    filter: drop-shadow(0px -3px 6px rgba(0, 0, 0, 0.3));
  }

  .project-table-wrapper {
    padding: 1rem 1rem 1rem 2.25rem;
    border-bottom: 1px solid #dddddd;
  }

  .project-table-header {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr;
    gap: 16px;
    background-color: ${sctheme.system.infoLight};
    border-bottom: 1px solid #dddddd;
    color: ${sctheme.grays.$900};
    font-size: 12px;
    font-weight: bold;
    padding: 0.5rem;
  }

  .project-table-results {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr;
    gap: 16px;
    border-bottom: 1px solid #dddddd;
    padding: 1rem 0 1rem 0.5rem;

    &.project-old-reference {
      background-color: ${sctheme.grays.$100};
    }

    .project-old-link {
      color: ${sctheme.grays.$600};
      text-align: right;
      font-size: 16px;
    }

    .project-link {
      font-size: 14px;
      text-align: right;
      color: ${sctheme.blues.secondary};
    }
  }

  .trash {
    color: ${sctheme.grays.$600};
    cursor: pointer;
  }

  .totals-label {
    font-size: 11px;
    font-weight: bold;
  }

  .totals-value {
    color: ${sctheme.black};
    font-size: 14px;
    font-weight: bold;
  }

  .totals-grid {
    display: grid;
    grid-template-columns: 2fr 0.7fr 1.6fr 1.1fr 1.2fr 0.8fr;
    padding: 0 0 0 1.5rem;
    gap: 8px;

    .shift-right {
      margin-right: -0.75rem;
    }
  }
`;

export default styles(sctheme);
